export const CONFIRMATION_EDIT_STEP1 = {
  step: 1,
  name: 'confirmationEditStep1',
  completed: false,
}
export const CONFIRMATION_EDIT_STEP2 = {
  step: 2,
  name: 'confirmationEditStep2',
  completed: false,
}
export const CONFIRMATION_EDIT_STEP3 = {
  step: 3,
  name: 'confirmationEditStep3',
  completed: false,
}
export const CONFIRMATION_EDIT_STEP4 = {
  step: 4,
  name: 'confirmationEditStep4',
  completed: true,
}

export const WRITTEN_SURVEY_EDIT_STEP2 = {
  step: 2,
  name: 'writtenSurveyEditStep2',
  completed: false,
}
export const WRITTEN_SURVEY_EDIT_STEP3 = {
  step: 3,
  name: 'writtenSurveyEditStep3',
  completed: true,
}

export const FIELD_SURVEY_EDIT_STEP2 = {
  step: 2,
  name: 'fieldSurveyEditStep2',
  completed: false,
}
export const FIELD_SURVEY_EDIT_STEP3 = {
  step: 3,
  name: 'fieldSurveyEditStep3',
  completed: false,
}
export const FIELD_SURVEY_EDIT_STEP4 = {
  step: 4,
  name: 'fieldSurveyEditStep4',
  completed: true,
}

export const DETAIL_EDIT_STEP2 = {
  step: 2,
  name: 'detailEditStep2',
  completed: false,
}
export const DETAIL_EDIT_STEP3 = {
  step: 3,
  name: 'detailEditStep3',
  completed: true,
}

export const REPORT_EDIT_STEP2 = {
  step: 2,
  name: 'reportEditStep2',
  completed: false,
}
export const REPORT_EDIT_STEP3 = {
  step: 3,
  name: 'reportEditStep3',
  completed: true,
}

export const LEAVE_CONFIRM_EDIT_ROUTES = [
  CONFIRMATION_EDIT_STEP1,
  CONFIRMATION_EDIT_STEP2,
  CONFIRMATION_EDIT_STEP3,
  CONFIRMATION_EDIT_STEP4,
  WRITTEN_SURVEY_EDIT_STEP2,
  WRITTEN_SURVEY_EDIT_STEP3,
  FIELD_SURVEY_EDIT_STEP2,
  FIELD_SURVEY_EDIT_STEP3,
  FIELD_SURVEY_EDIT_STEP4,
  DETAIL_EDIT_STEP2,
  DETAIL_EDIT_STEP3,
  REPORT_EDIT_STEP2,
  REPORT_EDIT_STEP3,
]
